/**
 * SB Nation main siteCyclone Communities
 */
export const SB_NATION_PRODUCT_CYCLONE_COMMUNITY_ID =
  "b750955c-6e73-4300-8141-58b6f548cf3b";
export const BREAKAWAY_CYCLONE_COMMUNITY_ID =
  "8e811fe2-fb04-47b2-a2ac-9a726841a965";
export const PLAYING_THROUGH_CYCLONE_COMMUNITY_ID =
  "9ae273ba-5ca0-43b1-bdc1-5a926a1d4d25";
export const SBNATION_CYCLONE_COMMUNITY_ID =
  "777e4080-b46a-48a6-a0c2-1615393728e3";
export const MARCHMADNESS_CYCLONE_COMMUNITY_ID =
  "11c1cafe-d8f7-41fc-b14e-e24c89119315";
export const NFL_CYCLONE_COMMUNITY_ID = "59e618dd-fe1c-4011-953b-daae822a10cc";
export const NBA_CYCLONE_COMMUNITY_ID = "a7f9e3d2-4b1c-4a8e-9f2d-8c5e1b3a7f9e";
export const MLB_CYCLONE_COMMUNITY_ID = "15e5335c-b60f-4269-ba6b-8f71fdfca345";
export const NHL_CYCLONE_COMMUNITY_ID = "07dad4e5-9ead-4d80-ad30-f3fa1dc6f9c8";
export const SOCCER_CYCLONE_COMMUNITY_ID =
  "53f10a8c-88fb-41d0-868b-0c92857f6242";
export const COLLEGE_FOOTBALL_CYCLONE_COMMUNITY_ID =
  "1d0903f9-ef83-42e2-ab91-2b94e1aa6153";
export const COLLEGE_BASKETBALL_CYCLONE_COMMUNITY_ID =
  "a9fcaf25-64e0-47ce-826d-c80483210ad3";
export const FORMULA_ONE_CYCLONE_COMMUNITY_ID =
  "f900f32d-07c3-4c25-885d-cfa7f36dbd6b";
export const NFC_EAST_MIXTAPE_CYCLONE_COMMUNITY_ID =
  "31f52561-56d8-4911-a7f8-b6051c754795";
export const FISH_STRIPES_CYCLONE_COMMUNITY_ID =
  "7d6e612e-b01c-4d30-b5bb-3e76a8c9e322";
export const HALOS_HEAVEN_CYCLONE_COMMUNITY_ID =
  "df9693c9-57ec-4d35-a02c-ed83fdfc1077";
export const SABRES_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "bf3584da-4927-494b-87df-3d69a51d5a7c";
export const RED_WINGS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "f4f42b3c-8d6b-4b7b-9d3c-9a877c34856e";
export const FLORIDA_PANTHERS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "4fffac02-4199-4dc9-b925-f0729d217f4a";
export const CANADIENS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "f97b8862-daf1-4c91-a768-f0d84e8b5241";
export const SENATORS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "09d9c72d-7b79-46eb-b3d5-114356111d29";
export const LIGHTNING_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "f6dc88f3-27d9-4be3-a402-62551fdbf863";
export const MAPLE_LEAFS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "e0b364d0-b4c3-4abd-b342-4af1f3f402d4";
export const BLUE_JACKETS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "29a105a8-e0e8-4f04-b4f4-1715a97471cb";
export const NY_RANGERS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "dc191ac5-678e-4d53-af3d-50345509c4f2";
export const FLYERS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "a3678a6c-cb02-4717-a5be-7e467e4663ba";
export const CAPITALS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "94123c31-96ff-4f71-acf4-e271d5ce6ce8";
export const BLACKHAWKS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "2cd28489-8fb0-41ff-a36e-91df124e68f5";
export const STARS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "287a035d-f08d-4b48-8689-5637d6b8a543";
export const WILD_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "0a323bba-71c6-4d35-bb7a-f60913603950";
export const PREDATORS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "b80a4c53-1f7d-40b5-b0af-1932c8b0cde0";
export const BLUES_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "16ec4d11-427c-4a6b-bbce-44e1c13b3529";
export const MAMMOTH_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "b6c30522-f170-4921-afa8-4a386757444d";
export const WINNIPEG_JETS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "c9775b45-1992-465d-b7ca-a5d943f4a5ae";
export const ANAHEIM_DUCKS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "41e2b860-86ec-4e61-8ee1-fbba5dbcf39c";
export const FLAMES_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "096dff4d-a739-4b2a-8ff9-94e9ed478331";
export const COPPER_AND_BLUE_CYCLONE_COMMUNITY_ID =
  "cabfb551-0a85-4367-af86-cc3801fcf619";
export const LA_KINGS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "f129ce26-f834-444f-96f2-2262c1171dc7";
export const SHARKS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "c4141d81-c00e-459b-af6e-4795d8d7cb4e";
export const KRAKEN_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "06bfc026-686c-4b92-b614-590816317a48";
export const CANUCKS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "f6b2657c-af07-49f9-b8e2-dcb7128a7509";
export const GOLDEN_KNIGHTS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "37b73aea-a125-4207-9f70-e079b8d654a7";
export const HORNETS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "b9047c57-ce79-40e3-91a1-4fc50c146a86";
export const BULLS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "543892dd-e24b-4036-93a0-15c39e514b01";
export const NUGGETS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "c46ba167-8094-4677-afa8-fd3fc9c635c7";
export const PACERS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "f2300d69-58ad-48d5-a9d4-b09b6b64c62a";
export const GRIZZLIES_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "5de37dff-ad9a-4056-8720-347775d4eb42";
export const HEAT_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "49d9d6e5-01e1-44fc-ad69-45c7d8dfda82";
export const PELICANS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "494d5caf-bc93-48a5-9eaf-dc49541ca772";
export const THUNDER_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "f17a681f-4a91-49f0-b3cf-ed318a943893";
export const ORLANDO_PINSTRIPED_POST_CYCLONE_COMMUNITY_ID =
  "e8f8ea15-397f-4008-8adb-174741a12a5d";
export const SACRAMENTO_KINGS_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "e38f96ab-4c67-46aa-8424-8d3432ba9d3a";
export const PSG_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "4a85699b-a2b5-4d05-a283-332c243057b1";
export const GARNET_AND_BLACK_ATTACK_CYCLONE_COMMUNITY_ID =
  "28e98288-92c3-4df6-9cb1-e90dca289c3a";
export const COLLEGE_AND_MAGNOLIA_CYCLONE_COMMUNITY_ID =
  "ab817840-8316-4846-8677-305b95767bb9";
export const ARKANSAS_FIGHT_CYCLONE_COMMUNITY_ID =
  "ed9ef7e6-a1a2-44e6-8855-6418d23b13f5";
export const FOR_WHOM_THE_COWBELL_TOLLS_CYCLONE_COMMUNITY_ID =
  "694d54e0-250d-4547-9402-3a6efc228e54";
export const CRIMSON_AND_CREAM_MACHINE_CYCLONE_COMMUNITY_ID =
  "11556085-4b4f-4ddf-9e6a-01220905ca58";
export const CONQUEST_CHRONICLES_CYCLONE_COMMUNITY_ID =
  "afd0a9c9-4cc4-4e55-b3fb-91620fbfbfee";
export const VIVA_THE_MATADORS_CYCLONE_COMMUNITY_ID =
  "de0f0af4-d944-45dc-879b-e43a23eaa1e2";
export const BLOCK_U_CYCLONE_COMMUNITY_ID =
  "1a4812d5-f68b-4416-95c3-a7101f1361d9";
export const OUR_DAILY_BEARS_CYCLONE_COMMUNITY_ID =
  "cdede3b6-61d2-47a1-b010-16f067f82980";
export const COWBOYS_RIDE_FOR_FREE_CYCLONE_COMMUNITY_ID =
  "11bf2217-a9a3-4ef2-b779-0fb3dee55b1c";
export const CARDIAC_HILL_CYCLONE_COMMUNITY_ID =
  "29c19aed-a5b2-4e26-b849-66e10fbfc183";
export const CALIFORNIA_GOLDEN_BLOGS_CYCLONE_COMMUNITY_ID =
  "e3f2af82-d5ae-4829-a4de-380f91996cd4";
export const RULE_OF_TREE_CYCLONE_COMMUNITY_ID =
  "39537ab0-f60c-4413-8ffe-a47574b53c3b";
export const SMU_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "f8810049-ccff-43c6-94bd-929090143e6e";
export const SEATTLE_NBA_EXPANSION_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "7f75aa3f-28b0-4d69-82ac-41cf00da2a11";
export const LV_NBA_EXPANSION_COMMUNITY_CYCLONE_COMMUNITY_ID =
  "1abab584-89e6-4b64-9856-177bef7b80e7";

/**
 * All other SB Nation Cyclone Communities
 */
export const ACME_PACKING_COMPANY_CYCLONE_COMMUNITY_ID =
  "a446ceb6-48ea-4849-82e1-95ee30d08b55";
export const THE_AC_MILAN_OFFSIDE_CYCLONE_COMMUNITY_ID =
  "ce2d4fff-1c42-4422-b4cb-9ae485b5131f";
export const ADDICTED_TO_QUACK_CYCLONE_COMMUNITY_ID =
  "a8047418-5d95-4bc6-b6b1-4b64d5a026dd";
export const ALL_ABOUT_THE_JERSEY_CYCLONE_COMMUNITY_ID =
  "144c5e06-25a0-4020-b574-c08aa00feb71";
export const ALL_FOR_XI_CYCLONE_COMMUNITY_ID =
  "561fdf8b-3a86-416f-8536-3d82b5e60f65";
export const ALLIGATOR_ARMY_CYCLONE_COMMUNITY_ID =
  "a297353d-5eb9-42f9-a6e3-204e7872729b";
export const AMAZIN_AVENUE_CYCLONE_COMMUNITY_ID =
  "29b5663d-d287-442b-b43d-361117361a21";
export const ANCHOR_OF_GOLD_CYCLONE_COMMUNITY_ID =
  "a9d0653a-9bfa-49d2-92a0-2f5d8dbaf44c";
export const AND_THE_VALLEY_SHOOK_CYCLONE_COMMUNITY_ID =
  "8e9f1e37-b646-4640-bfbe-18684e2b4dda";
export const ANONYMOUS_EAGLE_CYCLONE_COMMUNITY_ID =
  "d8c6faa2-28dd-4dc5-9d63-dcb7d71b9f90";
export const ARROWHEAD_PRIDE_CYCLONE_COMMUNITY_ID =
  "c5d0907b-aa85-4ed7-ac12-bbeaa023ac0e";
export const A_SEA_OF_BLUE_CYCLONE_COMMUNITY_ID =
  "6cc8f673-791e-45fe-ab58-1cc51bbf5830";
export const ATHLETICS_NATION_CYCLONE_COMMUNITY_ID =
  "6bf6bd90-4107-470c-a569-1431d9352a11";
export const ARIZONA_DESERT_SWARM_CYCLONE_COMMUNITY_ID =
  "4af4632f-c70a-483c-911a-7f764397b35c";
export const AZ_SNAKE_PIT_CYCLONE_COMMUNITY_ID =
  "2ecf370f-8d9f-408f-9263-04436e846786";
export const BACKING_THE_PACK_CYCLONE_COMMUNITY_ID =
  "cabc0720-7c2d-4be2-8ac1-aa7fc7ef4868";
export const BAD_LEFT_HOOK_CYCLONE_COMMUNITY_ID =
  "45f9ce25-0f0b-4004-a265-e5824b7434af";
export const BALTIMORE_BEATDOWN_CYCLONE_COMMUNITY_ID =
  "615aae4e-58b2-416f-9b81-9666e3bd7474";
export const BANNERS_ON_THE_PARKWAY_CYCLONE_COMMUNITY_ID =
  "1f186f61-7599-4add-a747-913be313106f";
export const BARCA_BLAUGRANES_CYCLONE_COMMUNITY_ID =
  "0c76a6d3-479d-4152-917b-dcb3c20c1de8";
export const BATTERY_POWER_CYCLONE_COMMUNITY_ID =
  "eed16011-2956-4edd-ba58-e237cc32632d";
export const BATTLE_RED_BLOG_CYCLONE_COMMUNITY_ID =
  "a6bf659d-4d7e-4ed5-915f-e6546d05a087";
export const BAVARIAN_FOOTBALL_WORKS_CYCLONE_COMMUNITY_ID =
  "d77540dd-9660-4bbf-a3d6-1018ddb219a5";
export const BC_INTERRUPTION_CYCLONE_COMMUNITY_ID =
  "648532c3-3e95-4ba4-b6c2-e96d9a4d182f";
export const BEHIND_THE_STEEL_CURTAIN_CYCLONE_COMMUNITY_ID =
  "15cd39d7-cf69-4d7f-9dfe-2fc2f6e098f3";
export const BIG_BLUE_VIEW_CYCLONE_COMMUNITY_ID =
  "bbda911d-949c-41c1-b91e-8a74af653af3";
export const BIG_CAT_COUNTRY_CYCLONE_COMMUNITY_ID =
  "3d2be038-16d0-487a-9e66-b8d212f5e284";
export const BITTER_AND_BLUE_CYCLONE_COMMUNITY_ID =
  "ca1fb546-3504-493e-8133-48e7d59cf1e5";
export const BLACK_AND_GOLD_BANNERET_CYCLONE_COMMUNITY_ID =
  "aef1958e-d086-437a-bcab-d17fd20cc580";
export const BLACK_HEART_GOLD_PANTS_CYCLONE_COMMUNITY_ID =
  "2a73fda7-bdf4-489b-b69e-066ea7141f63";
export const BLACK_SHOE_DIARIES_CYCLONE_COMMUNITY_ID =
  "2c667624-20bf-46e3-a4e3-58d4d2e92df3";
export const BLACK_AND_WHITE_AND_READ_ALL_OVER_CYCLONE_COMMUNITY_ID =
  "ab487767-0787-4c0c-aeb5-4097580d800b";
export const BLAZERS_EDGE_CYCLONE_COMMUNITY_ID =
  "86747a8d-95f3-4356-a4d5-1715ef31bbf8";
export const BLEED_CUBBIE_BLUE_CYCLONE_COMMUNITY_ID =
  "76f175c7-2585-47c1-9f11-335dcb8adc5f";
export const BLEEDING_GREEN_NATION_CYCLONE_COMMUNITY_ID =
  "7910057f-ecb6-4744-bb0c-75a992cb3f8e";
export const BLESS_YOU_BOYS_CYCLONE_COMMUNITY_ID =
  "24feadb9-6a8d-4203-af59-13ef6e300a9b";
export const BLOGGER_SO_DEAR_CYCLONE_COMMUNITY_ID =
  "57b45c7d-bd22-4102-9f2e-7a17add7472d";
export const BLOGGING_THE_BOYS_CYCLONE_COMMUNITY_ID =
  "c3666d7b-761b-4e69-8b23-36d924c5d788";
export const BLOGGING_THE_BRACKET_CYCLONE_COMMUNITY_ID =
  "e89546f3-1215-4e36-9b20-75763263b2bd";
export const BLUEBIRD_BANTER_CYCLONE_COMMUNITY_ID =
  "845ff58b-b9ae-4078-99db-e3e5213cf146";
export const BOLTS_FROM_THE_BLUE_CYCLONE_COMMUNITY_ID =
  "0c21f2cf-daf0-4285-b38c-6a1972b08e5c";
export const BREW_CREW_BALL_CYCLONE_COMMUNITY_ID =
  "d7fd8990-2a9a-4382-bfc2-f0846cd3d80f";
export const BREW_HOOP_CYCLONE_COMMUNITY_ID =
  "24f88981-4b57-4a61-bf0f-0aabff6f8f38";
export const BRIGHT_SIDE_OF_THE_SUN_CYCLONE_COMMUNITY_ID =
  "bf94ef62-ce3c-49ba-9818-03dbee81dc97";
export const BRING_ON_THE_CATS_CYCLONE_COMMUNITY_ID =
  "b27c5f7a-e02c-4785-b34e-650376e10212";
export const BRUINS_NATION_CYCLONE_COMMUNITY_ID =
  "c8cbcf3b-66ca-4b12-a3b6-441fbf7f962f";
export const BT_POWERHOUSE_CYCLONE_COMMUNITY_ID =
  "92e3c499-45b9-4456-8501-71311ccbce08";
export const BUCKYS_5TH_QUARTER_CYCLONE_COMMUNITY_ID =
  "0020fd3f-c4a0-4e2f-afd3-127f0a96938e";
export const BUCS_DUGOUT_CYCLONE_COMMUNITY_ID =
  "677b9e66-58a4-4a5c-aa83-45cbd3ab4a41";
export const BUCS_NATION_CYCLONE_COMMUNITY_ID =
  "1bce5546-9fa4-447f-a903-a412982bd519";
export const BUFFALO_RUMBLINGS_CYCLONE_COMMUNITY_ID =
  "aa28cb96-e7ca-485f-b209-a3de52d56369";
export const BULLETS_FOREVER_CYCLONE_COMMUNITY_ID =
  "87208962-c48b-4d6d-b41b-7c13cebbfb95";
export const BURNT_ORANGE_NATION_CYCLONE_COMMUNITY_ID =
  "88380134-386b-4227-aec3-7bd211a3a0ba";
export const CAGESIDE_SEATS_CYCLONE_COMMUNITY_ID =
  "ae469e4e-2e76-48aa-b806-7e56e248777a";
export const CAMDEN_CHAT_CYCLONE_COMMUNITY_ID =
  "9d32aea6-a7b3-466b-b413-1d6836b0af95";
export const CANAL_STREET_CHRONICLES_CYCLONE_COMMUNITY_ID =
  "9a3d9ff5-6d73-4341-a524-8a120f02e981";
export const CANES_COUNTRY_CYCLONE_COMMUNITY_ID =
  "80cc8d78-8060-4115-ba64-6289d8f3b5bb";
export const CANIS_HOOPUS_CYCLONE_COMMUNITY_ID =
  "e5ad5835-07a4-4ca3-99bd-41844e4a0807";
export const CARD_CHRONICLE_CYCLONE_COMMUNITY_ID =
  "154c3f04-2187-4ad4-b66a-b43b0e8952b1";
export const CARTILAGE_FREE_CAPTAIN_CYCLONE_COMMUNITY_ID =
  "38669b58-b5d0-4d75-ad75-0ec329540de9";
export const CASUAL_HOYA_CYCLONE_COMMUNITY_ID =
  "4c3ec771-7761-4c52-aa77-24d331c89ab1";
export const CAT_SCRATCH_READER_CYCLONE_COMMUNITY_ID =
  "793aac58-6441-4a46-ba50-1ee712e95378";
export const CELTICSBLOG_CYCLONE_COMMUNITY_ID =
  "8afb5f79-b188-4e7e-af57-8ded27bc964d";
export const CHIESA_DI_TOTTI_CYCLONE_COMMUNITY_ID =
  "4ad14d7e-adc6-4c84-8864-1863b642edba";
export const CINCY_JUNGLE_CYCLONE_COMMUNITY_ID =
  "da3f6132-d92b-4598-be80-3980368ee3d0";
export const CLIPS_NATION_CYCLONE_COMMUNITY_ID =
  "d8ee1eda-cf2a-4907-8e69-44bf1c1e78dd";
export const COMING_HOME_NEWCASTLE_CYCLONE_COMMUNITY_ID =
  "c1ba5522-a35f-4e72-ae01-d4054d9c5b16";
export const CORN_NATION_CYCLONE_COMMUNITY_ID =
  "93865050-e00d-48f2-bc77-d1ae9b0f75d9";
export const COUGCENTER_CYCLONE_COMMUNITY_ID =
  "77945c81-1069-48fe-96cd-31a3b54e4df1";
export const COVERING_THE_CORNER_CYCLONE_COMMUNITY_ID =
  "b5aaba37-094b-441a-93c0-8ee65d85cb45";
export const THE_CRAWFISH_BOXES_CYCLONE_COMMUNITY_ID =
  "635bbc4c-1e3c-4be4-806d-537cb36a2788";
export const THE_CRIMSON_QUARRY_CYCLONE_COMMUNITY_ID =
  "75205b9a-8d37-4d99-acb1-9ae16c8ab3a4";
export const DAILY_NORSEMAN_CYCLONE_COMMUNITY_ID =
  "1c962d17-2b31-4604-af34-306d6b5e7c07";
export const DAWGS_BY_NATURE_CYCLONE_COMMUNITY_ID =
  "3bd8d29b-5df5-4788-9291-b33bbf00ac7a";
export const DAWG_SPORTS_CYCLONE_COMMUNITY_ID =
  "0e7cd6ad-c100-4085-91ec-cc83c84ce44f";
export const DETROIT_BAD_BOYS_CYCLONE_COMMUNITY_ID =
  "15ff4555-6ad9-4c42-b00c-e333c911f007";
export const DRAYSBAY_CYCLONE_COMMUNITY_ID =
  "358a6099-7e34-4c74-b63f-dcbcd2e402c9";
export const DUKE_BASKETBALL_REPORT_CYCLONE_COMMUNITY_ID =
  "3220c6b6-d773-439e-844c-bcccd89daaea";
export const FEAR_THE_SWORD_CYCLONE_COMMUNITY_ID =
  "d7e4aaa0-df19-4c55-bd77-84d5a97c5422";
export const FEAR_THE_WALL_CYCLONE_COMMUNITY_ID =
  "a9e351f8-75a4-4418-bbcf-34d6b5492e8c";
export const FEDERAL_BASEBALL_CYCLONE_COMMUNITY_ID =
  "bf4440fd-9734-44cf-9dc0-3a145802712b";
export const FIELD_GULLS_CYCLONE_COMMUNITY_ID =
  "8dd330fa-87aa-4201-9719-58474140db63";
export const FMF_STATE_OF_MIND_CYCLONE_COMMUNITY_ID =
  "18b01bb8-3cde-490d-a681-99410da211c0";
export const FOSSE_POSSE_CYCLONE_COMMUNITY_ID =
  "5e7b1f54-e01a-49d0-be9f-e1c3f269c591";
export const FROGS_O_WAR_CYCLONE_COMMUNITY_ID =
  "49e2a356-1ded-406d-9f12-fd8df7b18c22";
export const FROM_THE_RUMBLE_SEAT_CYCLONE_COMMUNITY_ID =
  "a877e64b-a81d-499a-83a6-7c6bb07726ae";
export const GANG_GREEN_NATION_CYCLONE_COMMUNITY_ID =
  "379ad422-96c5-4fce-a4f2-2f902ddd8b27";
export const GASLAMP_BALL_CYCLONE_COMMUNITY_ID =
  "2f9fac5a-1b59-41d0-bf2e-f7b41e0063a2";
export const GOBBLER_COUNTRY_CYCLONE_COMMUNITY_ID =
  "d7d9b6ce-0993-42ca-b785-d7f46377edec";
export const GOLDEN_STATE_OF_MIND_CYCLONE_COMMUNITY_ID =
  "ba91bb68-c3a5-4abd-abaa-c9e1e64d6df8";
export const GOOD_BULL_HUNTING_CYCLONE_COMMUNITY_ID =
  "289c9acf-256c-413f-8ac4-d8e16f2d1655";
export const HAMMER_AND_RAILS_CYCLONE_COMMUNITY_ID =
  "de429510-14a6-4d16-849f-4e392b0ab61a";
export const HOGS_HAVEN_CYCLONE_COMMUNITY_ID =
  "6f203ef9-4cc5-4910-8818-92b1f5992fba";
export const HOUSE_OF_SPARKY_CYCLONE_COMMUNITY_ID =
  "e22bf74e-4672-41e8-a9e8-97033adc78a9";
export const HUSTLE_BELT_CYCLONE_COMMUNITY_ID =
  "2206adec-1d3c-40db-8e36-b9df26fc118e";
export const INSIDE_NU_CYCLONE_COMMUNITY_ID =
  "5535ac2c-37de-41a6-9d8b-9e0c267d2dc0";
export const INTO_THE_CALDERON_CYCLONE_COMMUNITY_ID =
  "5c58dbff-414d-4092-a87f-87ba4edcda17";
export const LAND_GRANT_HOLY_LAND_CYCLONE_COMMUNITY_ID =
  "9825d761-6187-469a-b386-5c87d8c26ddc";
export const LIBERTY_BALLERS_CYCLONE_COMMUNITY_ID =
  "22e45d4b-230f-401f-973e-e9b8e776896e";
export const LIGHTHOUSE_HOCKEY_CYCLONE_COMMUNITY_ID =
  "a33fd586-9e19-40bb-af8c-341e0cb96fae";
export const THE_LIVERPOOL_OFFSIDE_CYCLONE_COMMUNITY_ID =
  "9d34dcea-2e44-4b82-8544-ef3ec52d17e5";
export const LONE_STAR_BALL_CYCLONE_COMMUNITY_ID =
  "95c96cb7-1427-4570-922f-7238698bf854";
export const LOOKOUT_LANDING_CYCLONE_COMMUNITY_ID =
  "2eb780ee-aa64-456d-b829-b06e2a2dcd8f";
export const MAIZE_N_BREW_CYCLONE_COMMUNITY_ID =
  "fe3c95db-3d67-49ee-95a7-12755463987a";
export const MANAGING_MADRID_CYCLONE_COMMUNITY_ID =
  "d1519754-f366-4c04-9571-1480bd323eaa";
export const MAVS_MONEYBALL_CYCLONE_COMMUNITY_ID =
  "2594eeb9-3042-4a12-8994-f11639411191";
export const MCCOVEY_CHRONICLES_CYCLONE_COMMUNITY_ID =
  "b6ab48d6-76ca-46d5-ac88-55117d30385a";
export const MID_MAJOR_MADNESS_CYCLONE_COMMUNITY_ID =
  "ba68eef1-ce3a-4490-8f38-b84b3b55c488";
export const MILE_HIGH_HOCKEY_CYCLONE_COMMUNITY_ID =
  "5cc2f6f0-a34f-4f13-8eaa-41ad7c2dac12";
export const MILE_HIGH_REPORT_CYCLONE_COMMUNITY_ID =
  "d277bc55-c174-496d-8f7a-17548404c5f4";
export const MMA_FIGHTING_CYCLONE_COMMUNITY_ID =
  "a4840748-e542-4bb7-8e56-de320e43377a";
export const MMAMANIA_CYCLONE_COMMUNITY_ID =
  "13354dec-1d3c-40db-8e36-b9df26fc257d";
export const MUSIC_CITY_MIRACLES_CYCLONE_COMMUNITY_ID =
  "7081e1de-888c-4153-bd5e-f538b99eb172";
export const MOUNTAIN_WEST_CONNECTION_CYCLONE_COMMUNITY_ID =
  "8dfaea63-6bc1-4ac4-97b0-05ca3ffdb752";
export const NETSDAILY_CYCLONE_COMMUNITY_ID =
  "77700d24-b5a0-4100-a887-97f201d34c96";
export const NEVER_MANAGE_ALONE_CYCLONE_COMMUNITY_ID =
  "6af98ed9-5ffd-4fb0-937e-80f86b049e7d";
export const NINERS_NATION_CYCLONE_COMMUNITY_ID =
  "b3979275-bcea-4dad-8957-192e46ab4171";
export const TROY_NUNES_IS_AN_ABSOLUTE_MAGICIAN_CYCLONE_COMMUNITY_ID =
  "250d3fc7-3451-45ac-b5c4-21d030fba0aa";
export const OFF_TACKLE_EMPIRE_CYCLONE_COMMUNITY_ID =
  "8e20227c-3fc7-48ee-b69c-acbb29f49f4d";
export const ONE_FOOT_DOWN_CYCLONE_COMMUNITY_ID =
  "3d212a88-296a-43e2-bd09-f3306bfb69d9";
export const ON_THE_BANKS_CYCLONE_COMMUNITY_ID =
  "ee164b7d-9aac-4ac5-a8b1-d401cfa2d13e";
export const OVER_THE_MONSTER_CYCLONE_COMMUNITY_ID =
  "960f324f-afb7-47bc-9515-8704017810af";
export const PATS_PULPIT_CYCLONE_COMMUNITY_ID =
  "839365f4-8538-4055-804e-6a453529641b";
export const PEACHTREE_HOOPS_CYCLONE_COMMUNITY_ID =
  "7dcf1336-87a8-4bf1-a4fb-753883afbdce";
export const PENSBURGH_CYCLONE_COMMUNITY_ID =
  "a40f31b6-be94-4324-be58-aabeef0ef7ad";
export const PINSTRIPE_ALLEY_CYCLONE_COMMUNITY_ID =
  "865a77e8-1147-4173-9b37-d9edda444986";
export const POSTING_AND_TOASTING_CYCLONE_COMMUNITY_ID =
  "c8fee18b-6ad7-4401-80d9-a526d34b342c";
export const POUNDING_THE_ROCK_CYCLONE_COMMUNITY_ID =
  "72c92f24-b5c9-4774-99c2-8b5695d5e2f6";
export const PRIDE_OF_DETROIT_CYCLONE_COMMUNITY_ID =
  "10625d49-f40f-4938-adcc-fdb23235fc9a";
export const PURPLE_ROW_CYCLONE_COMMUNITY_ID =
  "fe27429b-a98b-44f3-ac37-170a363dcb05";
export const THE_RALPHIE_REPORT_CYCLONE_COMMUNITY_ID =
  "81eb01ab-86e1-4ea1-861d-e2eefd404688";
export const RAPTORS_HQ_CYCLONE_COMMUNITY_ID =
  "2afed7c1-1b64-4647-b4ff-44298fa9a141";
export const RED_CUP_REBELLION_CYCLONE_COMMUNITY_ID =
  "88da4c00-dbef-46a4-91d7-7bc8b73f94bd";
export const RED_REPORTER_CYCLONE_COMMUNITY_ID =
  "c474cff6-6a04-489c-b6fd-695f6f34ed3b";
export const REVENGE_OF_THE_BIRDS_CYCLONE_COMMUNITY_ID =
  "67e983f5-aa1e-4bbd-a8f5-94a6fb56edfb";
export const ROCK_CHALK_TALK_CYCLONE_COMMUNITY_ID =
  "47a66bc8-383e-4943-9ea6-3bfb8636d222";
export const ROCK_M_NATION_CYCLONE_COMMUNITY_ID =
  "f8d37d27-8906-4cb1-a3cb-2472c5d14a92";
export const ROCKY_TOP_TALK_CYCLONE_COMMUNITY_ID =
  "e1487206-55f3-497e-b0a0-45341add0589";
export const ROKER_REPORT_CYCLONE_COMMUNITY_ID =
  "c4d2aa31-7945-4fea-98de-fc3b5484505f";
export const ROLL_BAMA_ROLL_CYCLONE_COMMUNITY_ID =
  "4418270e-c0db-4c49-94bb-e3ea4f431731";
export const ROYAL_BLUE_MERSEY_CYCLONE_COMMUNITY_ID =
  "b4cec2a3-f4ce-4a13-96cf-a175574e23cd";
export const ROYALS_REVIEW_CYCLONE_COMMUNITY_ID =
  "20695974-50cc-417e-8188-c7b988162d0c";
export const RUMBLE_IN_THE_GARDEN_CYCLONE_COMMUNITY_ID =
  "2bd4e23d-8bc0-4ded-9783-a6912f85169d";
export const SHAKIN_THE_SOUTHLAND_CYCLONE_COMMUNITY_ID =
  "9efaad6b-375e-4b0e-b71c-41ca1dff30ed";
export const SILVER_AND_BLACK_PRIDE_CYCLONE_COMMUNITY_ID =
  "8833a13d-16a4-42eb-8e22-1951dc52e11d";
export const SILVER_SCREEN_AND_ROLL_CYCLONE_COMMUNITY_ID =
  "a5716f5b-b6e4-44ae-b585-8c37c197b8e1";
export const SLC_DUNK_CYCLONE_COMMUNITY_ID =
  "279adbe2-8f24-4840-b276-88b7fe5a0138";
export const THE_SLIPPER_STILL_FITS_CYCLONE_COMMUNITY_ID =
  "d372ce6e-1509-4e21-b903-9a58aee1cef8";
export const THE_SMOKING_MUSKET_CYCLONE_COMMUNITY_ID =
  "028228ed-37a8-4bbd-8234-a8409990981b";
export const SOUTH_SIDE_SOX_CYCLONE_COMMUNITY_ID =
  "513a7499-f833-460c-84a6-1f3ba2cc871a";
export const STAMPEDE_BLUE_CYCLONE_COMMUNITY_ID =
  "bdf2cfee-20d2-4ba1-b24b-2c3aa8f2e415";
export const STANLEY_CUP_OF_CHOWDER_CYCLONE_COMMUNITY_ID =
  "fbe18188-2aa8-45f1-8290-b16c417ef838";
export const STARS_AND_STRIPES_FC_CYCLONE_COMMUNITY_ID =
  "d1febce7-8a79-40cf-8f5b-a78f1f7be03c";
export const STATE_OF_THE_U_CYCLONE_COMMUNITY_ID =
  "40dac3c4-3c47-48b6-afc2-bd4e247784b5";
export const STREAKING_THE_LAWN_CYCLONE_COMMUNITY_ID =
  "b4fdb6e6-9ed1-4030-a536-78d7c90c29d1";
export const SWISH_APPEAL_CYCLONE_COMMUNITY_ID =
  "e41ebb53-f77f-47b7-ad0e-3d6eeedfa4fe";
export const TAR_HEEL_BLOG_CYCLONE_COMMUNITY_ID =
  "fbcbd64f-9adc-4c46-9950-f13763f170a0";
export const TESTUDO_TIMES_CYCLONE_COMMUNITY_ID =
  "ac424697-1e30-4e89-bc87-b8b514c31cda";
export const THE_BUSBY_BABE_CYCLONE_COMMUNITY_ID =
  "2b56ce69-9b0c-43df-92e3-fe479cdb9782";
export const THE_CHAMPAIGN_ROOM_CYCLONE_COMMUNITY_ID =
  "a2a9b964-54f5-4fdd-be59-61fd033b6fc9";
export const THE_DAILY_GOPHER_CYCLONE_COMMUNITY_ID =
  "e2a2c715-c2a1-4585-9e75-661072becc4a";
export const THE_DREAM_SHAKE_CYCLONE_COMMUNITY_ID =
  "b8425b65-381b-4e08-b002-7da8d1e48d05";
export const THE_FALCOHOLIC_CYCLONE_COMMUNITY_ID =
  "f93a42df-67f2-4850-aca5-5156a8689cee";
export const THE_GOOD_PHIGHT_CYCLONE_COMMUNITY_ID =
  "a4ac6d13-d800-4ebe-bf9d-67a4a2e6cf7c";
export const THE_ONLY_COLORS_CYCLONE_COMMUNITY_ID =
  "c480b2fd-f9e7-435a-beb6-a31db23a4ae0";
export const THE_PHINSIDER_CYCLONE_COMMUNITY_ID =
  "3da058f1-4e82-408a-975f-6dea2445bb14";
export const THE_SHORT_FUSE_CYCLONE_COMMUNITY_ID =
  "8f71c916-2467-4acd-b1be-a5ffa5f1eefa";
export const THE_TILEHURST_END_CYCLONE_COMMUNITY_ID =
  "2567764c-c928-408d-88c1-9af5ab9564a3";
export const THE_UCONN_BLOG_CYCLONE_COMMUNITY_ID =
  "760e1f98-9998-4a63-bb2c-aefb0564a2c5";
export const TOMAHAWK_NATION_CYCLONE_COMMUNITY_ID =
  "662e009e-8ab7-4544-8163-a772706e687a";
export const TRUE_BLUE_LA_CYCLONE_COMMUNITY_ID =
  "799deb7b-2a7e-4cb4-911f-710f4ad313f4";
export const TURF_SHOW_TIMES_CYCLONE_COMMUNITY_ID =
  "941c7396-1115-4740-bf2c-e2fc90f98f2c";
export const TWINKIE_TOWN_CYCLONE_COMMUNITY_ID =
  "ec475e14-226d-4d9a-8ec0-bb89c8f713a2";
export const UNDERDOG_DYNASTY_CYCLONE_COMMUNITY_ID =
  "1ded2d49-4aaf-4528-92f6-a1a3fe905a9a";
export const UW_DAWG_POUND_CYCLONE_COMMUNITY_ID =
  "49a96fd7-ce63-4c3a-9528-20dc7ad7d418";
export const VANQUISH_THE_FOE_CYCLONE_COMMUNITY_ID =
  "ec7448fe-49b1-4a49-bb8f-e5d3756d02b7";
export const VIOLA_NATION_CYCLONE_COMMUNITY_ID =
  "8fba2fbc-e11a-4131-8598-be867109267c";
export const VIVA_EL_BIRDOS_CYCLONE_COMMUNITY_ID =
  "81890cb2-2827-47e8-b33e-b23406e37b6d";
export const VU_HOOPS_CYCLONE_COMMUNITY_ID =
  "34ab39d7-cf69-4d7f-9dfe-2fc2f6e098e2";
export const WE_AINT_GOT_NO_HISTORY_CYCLONE_COMMUNITY_ID =
  "33f9e3fa-9eb3-412c-a861-aad7a8a32605";
export const WIDE_RIGHT_AND_NATTY_LITE_CYCLONE_COMMUNITY_ID =
  "07b4a012-fd21-47f9-bc0f-7a9b1ad8c95f";
export const WINDY_CITY_GRIDIRON_CYCLONE_COMMUNITY_ID =
  "463076da-9b20-4a6e-81cd-53c80e485022";
